export const NEW_CLUB = 'newClub';
export const NEW_GIFT = 'newGift';
export const NEW_PAYMENT = 'newPayment';
export const CARD_CHANGE = 'cardChange';
export const UPDATE_CLUB = 'updateClub';
